import {memo, Suspense, useMemo} from 'react'
import {graphql, useLazyLoadQuery} from 'react-relay'

import BuildsFetcher from '../../../../../containers/BuildsFetcher'
import type {ChangeId} from '../../../../../types'
import {stringifyId} from '../../../../../types'
import {getChange} from '../../Changes.selectors'
import ChangeBuilds from '../ChangeBuilds/ChangeBuilds'

import type {BuildsTabQuery} from './__generated__/BuildsTabQuery.graphql'

import {useAppSelector} from 'src/hooks/react-redux'

const query = graphql`
  query BuildsTabQuery($changeLocator: String!) {
    changeBuildTypes(changeLocator: $changeLocator) {
      ...ChangeBuilds_buildTypes
    }
  }
`

type Props = {
  buildTypesLocator: string
  buildsLocator: string
}

function BuildsTab({buildTypesLocator, buildsLocator}: Props) {
  const {changeBuildTypes = null} = useLazyLoadQuery<BuildsTabQuery>(query, {
    changeLocator: buildTypesLocator,
  })

  return <ChangeBuilds buildsLocator={buildsLocator} buildTypesKey={changeBuildTypes} />
}

type ContainerProps = {
  changeId: ChangeId
}

export default memo(function BuildsTabContainer({changeId}: ContainerProps) {
  const personal = useAppSelector(state => getChange(state, changeId)?.personal)

  const buildTypesLocator = `id:${stringifyId(changeId)},personal:${personal || false}`
  const buildsLocator = `${buildTypesLocator},count:100001`

  return useMemo(
    () => (
      <BuildsFetcher
        locator={buildsLocator}
        customEndpoint={`/changes/${buildTypesLocator}/firstBuilds`}
        withQueued
      >
        <Suspense>
          <BuildsTab buildTypesLocator={buildTypesLocator} buildsLocator={buildsLocator} />
        </Suspense>
      </BuildsFetcher>
    ),
    [buildTypesLocator, buildsLocator],
  )
})
